// DCG native cart bridge (piggybacks theme cart dropdown refresh)
window.DCG = window.DCG || {};
window.DCG.cart = window.DCG.cart || {};

window.DCG.cart.addItem = async function ({ id, quantity = 1, properties }) {
  // ── Pre-flight enforcement ─────────────────────────────────────────────
  // dcg-cart-enforcer.js (loaded before this script) checks limit:N tags
  // and cross-references the current cart to prevent over-limit adds.
  // If preflight is unavailable (edge case), we fall through silently.
  if (window.DCG && typeof window.DCG.enforcer === "object" && window.DCG.enforcer) {
    let _enforcerBlocked = false;
    try {
      const check = await window.DCG.enforcer.preflight(id, quantity);
      if (check.blocked) {
        // Mark as a deliberate block before throwing so the catch below
        // knows to re-throw rather than silently swallow the error.
        _enforcerBlocked = true;
        window.DCG.enforcer.showToast(check.message || "Purchase limit reached.");
        throw new Error(check.message || "Purchase limit reached.");
      }
      if (check.message) {
        // Qty was reduced — show reason, but still proceed with the add
        window.DCG.enforcer.showToast(check.message);
      }
      // Use the (possibly adjusted) quantity going forward
      quantity = check.qty;
    } catch (enforceErr) {
      if (_enforcerBlocked) {
        // Deliberate block — re-throw so productAddToCart's .catch handler
        // cleans up the .adding button state without showing a success flash.
        throw enforceErr;
      }
      // Otherwise (network failure inside preflight) log and allow the add
      console.warn("[DCG] enforcer preflight error — allowing add:", enforceErr);
    }
  }

  const payload = { id: Number(id), quantity: Number(quantity || 1) };
  if (properties) payload.properties = properties;

  const res = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    // Shopify returns JSON error with "description"
    let msg = "Add to cart failed";
    try {
      const data = await res.json();
      msg = data?.description || data?.message || msg;
    } catch (_) {
      msg = await res.text();
    }
    throw new Error(msg);
  }

  const data = await res.json();

  // THEME-NATIVE refresh hook:
  if (typeof window.adjustCartDropDown === "function") {
    window.adjustCartDropDown();
  } else {
    // fallback: at least trigger common theme events
    document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  }

  // Always dispatch cart:updated so dcg-cart-enforcer.js can run its
  // drawer audit regardless of which refresh path was taken above.
  document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));

  return data;
};

// ─────────────────────────────────────────────────────────────────────────────
// productAddToCart — global shim for shop.js
//
// shop.js (loaded on every page) calls productAddToCart(variantID, qty) inside
// its .nm-addToCart.enable click handler. That function is normally defined in
// quickview.js, but quickview.js is NOT loaded on the collection page.
// This shim fills that gap so the native ATC pathway works on collections
// without pulling in all of quickview.js.
//
// Guard: only define it if quickview.js hasn't already done so, so other pages
// (product, quick-view) continue to use their existing implementation.
// ─────────────────────────────────────────────────────────────────────────────
// CHECK_SVG is set by dcg-product-card.js on window.DCG before this runs.
// Fallback inline in case load order is unexpected.
var _CHECK_SVG = '<svg class="dcg-atc-icon" viewBox="0 0 20 20" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="4 10 8.5 15 16 6"/></svg>';

if (typeof window.productAddToCart !== "function") {
  window.productAddToCart = function (varID, qty) {
    // Snapshot which buttons are in .adding state at the moment of the call.
    // shop.js adds .adding synchronously before calling us, so this is the
    // exact set of buttons the user just clicked.
    var pendingBtns = Array.from(
      document.querySelectorAll(".nm-addToCart.adding")
    );

    window.DCG.cart
      .addItem({ id: varID, quantity: qty })
      .then(function () {
        var checkSvg = (window.DCG && window.DCG.CHECK_SVG) || _CHECK_SVG;

        pendingBtns.forEach(function (btn) {
          btn.classList.remove("adding");

          // Store the original button HTML (set by dcg-product-card.js as a data-attr)
          // so we can restore it after the success flash.
          var origHtml = btn.dataset.dcgOrigHtml || btn.innerHTML;

          // Swap to checkmark. On desktop: icon only (label hidden by CSS).
          // On mobile: icon + "Added!" text label.
          btn.innerHTML = checkSvg + '<span class="dcg-atc-label">Added!</span>';
          btn.classList.add("dcg-atc-success");

          setTimeout(function () {
            btn.classList.remove("dcg-atc-success");
            btn.innerHTML = origHtml;
          }, 1400);
        });
      })
      .catch(function (err) {
        console.error("[DCG] Add to cart error:", err.message);
        // On error just clean up .adding — no success flash
        pendingBtns.forEach(function (btn) {
          btn.classList.remove("adding");
        });
      });
  };
}